// @ts-nocheck
import axios from "axios";
import React from "react";
import LOGO from "../assets/images/newLogo.png";
import APPNAME from "../assets/images/appname.png";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { BASE_URL } from "../Constants/BaseUrl";

export const ForgetPassword = () => {
  const [email, setEmail] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email.toLowerCase());
  };

  React.useEffect(() => {
    return () => {
      setEmail("");
      setLoading(false);
    };
  }, []);

  const handleVerify = async () => {
    if (!isValidEmail(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      const data = new FormData();
      data.append("email", email);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${BASE_URL}user/forget-password`,
        data,
      };

      const response = await axios.request(config);
      console.log(
        "Response forgot password:",
        JSON.stringify(response.data, null, 2)
      );

      if (response.data.success) {
        toast.success("Verification email sent successfully!");
        setTimeout(() => {
          navigate("/verify-code", {
            state: {
              email,
              otp: response.data.otp,
              user_id: response.data.user_id,
            },
          });
        }, 2000);
      } else {
        alert(response.data.message || "Failed to send verification email.");
      }
    } catch (error) {
      console.log("Error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#121212] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[#1e1e1e] rounded-lg shadow-lg p-8">
        <div className="flex justify-center mb-4">
          <img src={LOGO} alt="Logo" className="h-40 w-40 object-contain" />
        </div>
        <div className="flex justify-center mb-6">
          <img src={APPNAME} alt="App Name" className="h-16 object-contain" />
        </div>

        <h2 className="text-2xl font-bold text-center text-white mb-6 uppercase">
          Reset Your Password
        </h2>

        <div className="mb-6">
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] text-white placeholder-gray-400 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
            autoCapitalize="none"
          />

          <button
            onClick={handleVerify}
            disabled={loading}
            className={`w-full mt-4 p-3 bg-red-600 text-white rounded-md font-semibold uppercase hover:bg-red-700 transition-colors ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {loading ? "Loading..." : "Reset Password"}
          </button>
        </div>

        <a
          href="/login"
          className="text-center block text-gray-600 hover:text-red-600 transition-colors"
        >
          Return to Sign In Page
        </a>
      </div>
      <ToastContainer />
    </div>
  );
};
